// LatestBookings.jsx
import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const LatestBookings = ({ bookings, formatCurrency }) => {
    const getStatusColor = (status) => {
        status = status.toLowerCase();
        if (status === 'completed') return 'success';
        if (status === 'in progress') return 'info';
        if (status === 'pending') return 'warning';
        if (status === 'cancelled') return 'danger';
        return 'secondary';
    };

    const formatDate = (dateString) => {
        const options = { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        };
        return new Date(dateString).toLocaleDateString('id-ID', options);
    };

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Latest Bookings</h5>
                <a href="#" className="btn btn-sm btn-outline-primary">View All</a>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Service</th>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bookings.map((booking) => (
                                <tr key={booking.id}>
                                    <td>#{booking.id}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="me-2">
                                                <Icon icon="mdi:spa" className="text-primary" />
                                            </div>
                                            {booking.nama_service}
                                        </div>
                                    </td>
                                    <td>{formatDate(booking.created_at)}</td>
                                    <td>{formatCurrency(booking.harga_service)}</td>
                                    <td>
                                        <span className={`badge bg-${getStatusColor(booking.status)}-subtle text-${getStatusColor(booking.status)}`}>
                                            {booking.status}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default LatestBookings;